let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lWqTy")).then(() => parcelRequire('faY7t'));